var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.currentPath == 2
      ? _c(
          "div",
          {
            staticClass: "footer",
            class: [_vm.addClassHome ? "addClassHome" : ""],
          },
          [_c("footerCont")],
          1
        )
      : _c("div", [
          _vm.currentPath == 3
            ? _c(
                "div",
                {
                  staticClass: "footer",
                  class: [_vm.addClass ? "addClass" : ""],
                  style: { width: _vm.screenWidth, float: "right" },
                },
                [_c("footerCont")],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }